import {useContext, useState} from 'react';
import {
  TwilioClientProvider as ConversationsTwilioClientProvider,
  TwilioClient,
} from '@stripe-internal/twilio-conversations-client';
import {
  ClientUrls,
  ObservabilityConfig,
} from '@stripe-internal/conversations-client';
import {ConfigContext} from '../ConfigProvider';
import {useObservability} from '../ObservabilityProvider';
import {useProfile} from '../ProfileProvider';
import {useApi} from '../ApiProvider/ApiProvider';

type Props = {
  children: JSX.Element;
};

export const TwilioClientProvider = ({children}: Props) => {
  const observability = useObservability();
  const {
    audience,
    entrypoint: entryPoint,
    stripeThirdPartyBaseUrl,
  } = useContext(ConfigContext);
  const {
    profile: {featureFlags},
  } = useProfile();
  const api = useApi();

  const urls: Partial<ClientUrls> = {
    tokenUrl: `/api/chat-token?audience=${audience}&entrypoint=${entryPoint}`,
    conversationUrl: `/api/start-chat?audience=${audience}&entrypoint=${entryPoint}`,
  };

  const clientOpts: {
    clientFetch?: typeof fetch;
    urls?: Partial<ClientUrls>;
    observability?: ObservabilityConfig;
  } = {urls, observability};

  if (featureFlags.enablePassFetchToConversationsClient) {
    clientOpts.clientFetch = api.fetch;
  }

  const [client] = useState(() => new TwilioClient(clientOpts));

  return (
    <ConversationsTwilioClientProvider
      value={client}
      observability={observability}
      urls={urls}
      baseURL={stripeThirdPartyBaseUrl}
    >
      {children}
    </ConversationsTwilioClientProvider>
  );
};
